export function esc(s) {
  return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;')
    .replace(/>/g, '&gt;').replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function escH(s) {
  var d = document.createElement('div');
  d.textContent = s;
  return d.innerHTML;
}

export function formatOwnerText(s) {
  var t = esc(s);
  t = t.replace(/(&lt;br\s*\/?&gt;\s*){1,}/gi, '\n');
  t = t.replace(/\n{3,}/g, '\n\n');
  return t.replace(/\n/g, '<br>');
}

export function stars(r) {
  r = Math.round(r || 0);
  return '\u2605'.repeat(r) + '\u2606'.repeat(Math.max(0, 5 - r));
}

export function highlight(raw, q) {
  if (!q) return esc(raw);
  var text = raw || '', lower = text.toLowerCase(), lq = q.toLowerCase();
  var result = '', i = 0;
  while (i < text.length) {
    var j = lower.indexOf(lq, i);
    if (j === -1) { result += esc(text.slice(i)); break; }
    result += esc(text.slice(i, j));
    result += '<mark>' + esc(text.slice(j, j + q.length)) + '</mark>';
    i = j + q.length;
  }
  return result;
}
